import { Anchor, Banner, Button } from "@newsela/angelou";

import { ADMIN_CONSOLE_CONTENT_PROMOTION_PATHNAME } from "@/components/ContentPromotions/constants";
import {
  bannerCss,
  bannerTextCss,
  goToAdminLinkCss,
  innerBannerContentCss,
  pageLinkCss,
  publishButtonCss,
} from "./BannerToPublishContentPromotionForms.style";

export interface BannerToPublishContentPromotionFormsProps {
  gradeRangeText: string;
  handleSelectionToPublishContentPromotionForm: () => Promise<void>;
  isFormPublished: boolean;
  isVisible?: boolean;
  selectedFormRedirectUrl: string;
  subjectProductLabel: string;
}

const BannerToPublishContentPromotionForms = ({
  gradeRangeText,
  handleSelectionToPublishContentPromotionForm,
  isFormPublished,
  isVisible = false,
  selectedFormRedirectUrl,
  subjectProductLabel,
}: BannerToPublishContentPromotionFormsProps) => {
  if (!isVisible) {
    return null;
  }
  return (
    <Banner
      __cssFor={{
        root: bannerCss,
        body: bannerTextCss,
        innerContentContainer: innerBannerContentCss,
      }}
      body={
        isFormPublished
          ? `Viewing published content promotion for ${subjectProductLabel} ${gradeRangeText}`
          : `Previewing content promotion for ${subjectProductLabel} ${gradeRangeText}`
      }
      bannerType={Banner.types.custom}
      __renderCtaSection={(spreadableProps) => {
        return (
          <div {...spreadableProps}>
            <Anchor
              dataProps={{
                "data-qa-selector": "make-changes-button",
              }}
              href={selectedFormRedirectUrl}
              __cssFor={{ root: pageLinkCss }}
            >
              Make changes
            </Anchor>
            {isFormPublished ? (
              <Anchor
                dataProps={{
                  "data-qa-selector": "go-to-admin-console-button",
                }}
                href={ADMIN_CONSOLE_CONTENT_PROMOTION_PATHNAME}
                __cssFor={{ root: goToAdminLinkCss }}
              >
                Return to content promotion
              </Anchor>
            ) : (
              <Button
                dataProps={{
                  "data-qa-selector": `publish-for-${subjectProductLabel}-button`,
                }}
                onClick={
                  handleSelectionToPublishContentPromotionForm as unknown as () => void
                }
                __cssFor={{ root: publishButtonCss }}
                flavor={Button.flavors.secondary}
              >
                Publish for {subjectProductLabel}
              </Button>
            )}
          </div>
        );
      }}
    />
  );
};

export default BannerToPublishContentPromotionForms;
